import { EntityService } from './EntityService';

export class ServerTimeService extends EntityService {
  static entity: string = 'app/config/server-time';
}
